import { useState } from 'react';
import RichTextEditor from 'react-rte';
import { RICH_TEXT_CONFIG } from 'core/constants';
import s from './styles.scss';
import PT from 'prop-types';
import * as DOMPurify from 'dompurify';
import { SafeHTML } from 'edrolo/domains/app';

export const RichText = ({
  blockResponse = {},
  onResponseChange = () => null,
  readOnly,
}) => {
  const { student_response: studentResponse } = blockResponse || '';

  const [value, setValue] = useState(
    blockResponse?.student_response
      ? RichTextEditor.createValueFromString(studentResponse, 'html')
      : RichTextEditor.createEmptyValue()
  );

  const handleChange = (newValue) => {
    setValue(newValue);
    onResponseChange({
      student_response: DOMPurify.sanitize(newValue.toString('html')),
    });
  };

  return (
    <div className={s.richText}>
      {readOnly ? (
        <SafeHTML className={s.content}>
          {studentResponse?.toString('html') || '&nbsp;'}
        </SafeHTML>
      ) : (
        <RichTextEditor
          value={value}
          onChange={handleChange}
          toolbarConfig={RICH_TEXT_CONFIG}
          className={s.content}
        />
      )}
    </div>
  );
};

RichText.propTypes = {
  blockResponse: PT.object,
  onResponseChange: PT.func,
  readOnly: PT.bool,
};
